const namespace = 'http://www.w3.org/2000/svg'

export default {
  props: {
    width: {
      default: 300
    },

    height: {
      default: 150
    },

    stroke: {
      default: 1.5
    },

    color: {
      type: String,
      default: '#000F55'
    }
  },

  data: () => ({
    value: '',
    shapes: [],
    outside: true,
    drawing: false
  }),

  render (createElement) {
    return createElement('img', {
      ref: 'signature',
      attrs: {
        src: this.src,
        draggable: false,
        tabindex: '0'
      },
      staticClass: ['signature'],
      style: {
        width: `${this.width}px`,
        height: `${this.height}px`,
        userSelect: 'none',
        userDrag: 'none'
      },
      on: {
        mousedown: this.mouseDown,
        touchstart: this.touchStart,
        mouseup: this.mouseUp,
        touchend: this.touchEnd,
        mousemove: this.mouseMove,
        touchmove: this.touchMove,
        mouseleave: this.mouseLeave,
        mouseenter: this.mouseEnter,
        focus: this.focus,
        blur: this.blur
      }
    })
  },

  computed: {
    shape () {
      return this.shapes[this.shapes.length - 1]
    },

    src () {
      return `data:image/svg+xml;base64,${window.btoa(this.serialize(false))}`
    }
  },

  mounted () {
    document.addEventListener('mouseup', (event) => this.mouseUpOutside(event))
  },

  methods: {
    /**
     * Ment to be called externally
     * @public
     * */
    clear () {
      this.shapes = []
      this.emitInput(null)
    },

    /**
     * Ment to be called externally
     * @public
     * */
    save () {
      const blob = new window.Blob([this.serialize()], {type: 'image/svg+xml'})
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.setAttribute('href', url)
      link.setAttribute('target', '_blank')
      link.setAttribute('download', 'signature.svg')
      link.click()
    },

    addShape () {
      this.shapes.push([])
    },

    addCommand (command, ...attributes) {
      this.shape.push(`${command}${attributes.join(' ')}`)
    },

    mouseUp () {
      this.drawing = false
      this.emitInput()
    },

    mouseUpOutside (event) {
      if (event.srcElement !== this.$refs.signature) {
        if (this.drawing) {
          this.mouseUp()
        }
      }
    },

    mouseLeave () {
      this.outside = true
    },

    mouseEnter ({offsetX: x, offsetY: y}) {
      if (this.outside && this.drawing) {
        this.addShape()
        this.addCommand('M', x, y)
        this.outside = false
      }
    },

    touchOffset (event, targetTouches = true, delegate) {
      if (event.targetTouches[0]) {
        const bounds = event.target.getBoundingClientRect()
        const target = targetTouches ? 'targetTouches' : 'changedTouches'
        const offsetX = event[target][0].clientX - bounds.left
        const offsetY = event[target][0].clientY - bounds.top
        delegate({offsetX, offsetY})
      }
    },

    mouseDown ({offsetX: x, offsetY: y}) {
      this.drawing = true
      this.outside = false
      this.addShape()
      this.addCommand('M', x, y)
    },

    touchStart (event) {
      event.preventDefault()
      this.touchOffset(event, false, this.mouseDown)
    },

    touchMove (event) {
      event.preventDefault()
      this.touchOffset(event, true, this.mouseMove)
    },

    touchEnd (event) {
      event.preventDefault()
      this.touchOffset(event, true, this.mouseUp)
    },

    mouseMove ({offsetX: x, offsetY: y}) {
      if (this.drawing && !this.outside) {
        this.addCommand('L', x, y)
      }
    },

    focus () {
      this.$emit('focus')
    },

    blur () {
      this.$emit('blur')
    },

    serialize (clip = true) {
      const element = document.createElementNS(namespace, 'svg')

      this.shapes
        .map(shape => {
          const path = document.createElementNS(namespace, 'path')
          path.setAttribute('fill', '#fff')
          path.setAttribute('fill-opacity', '0')
          path.setAttribute('stroke-linejoin', 'round')
          path.setAttribute('stroke-linecap', 'round')
          path.setAttribute('stroke', this.color)
          path.setAttribute('stroke-width', this.stroke)
          path.setAttribute('d', shape.join(' '))
          return path
        })
        .forEach(path => element.appendChild(path))

      element.style.position = 'fixed'
      element.style.opacity = '0'

      document.body.appendChild(element)

      const boundingBox = element.getBBox()
      const data = element.innerHTML

      document.body.removeChild(element)

      let width = clip ? boundingBox.width : this.width
      let height = clip ? boundingBox.height : this.height

      let y = clip ? boundingBox.y : 0
      let x = clip ? boundingBox.x : 0

      return `
      <svg
        xmlns="${namespace}"
        width="${width + this.stroke}"
        height="${height + this.stroke}"
        viewBox="${x - this.stroke} ${y - this.stroke} ${width + this.stroke * 2} ${height + this.stroke * 2}"
      >
       ${data}
      </svg>`
    },

    emitInput (output = this.serialize()) {
      this.value = output
      this.$emit('change', output)
      this.$emit('input', output)
      this.$emit('update:signature', output)
    }
  }
}
